import React, { useState } from 'react'
import { ConfigItem } from './ConfigItem'
import {
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Col,
  Row,
  FormGroup,
  Form,
  Input,
  Button,
} from 'react-bootstrap'
//import Checkbox from 'components/atoms/@vuexy/checkbox/CheckboxesVuexy'
import { Checkbox, Radio } from '@mui/material'
//import { Check, Minus, Search } from 'react-feather'
import Select from 'react-select'
//import * as Icon from 'react-feather'
import FeatherIcon from 'feather-icons-react'
import { EditDataSourceModal } from './EditDataSourceModal'
import httpClient from 'utility/httpClient.util'
import { ConfigItemGroup } from './ConfigItemGroup'

const SIZE_OPTIONS = [
  { label: 'A4', value: 'A4' },
  { label: 'Letter', value: 'Letter' },
  { label: 'Custom', value: 'Custom' },
]

const getDataSourceVariableName = (item = {}) =>
  `${item.dataSourceVariableName || ''}`.trim()
const DataSourceMenu = (props) => {
  const { variables } = props
  const menu = [
    { name: 'Text' },
    { name: 'Image' },
    { name: 'Date' },
    { name: 'Checkbox' },
    { name: 'Barcode' },
    { name: 'Qrcode' },
    { name: 'Table' },
    { name: 'Report' },
  ]
  const [state, setState] = useState({ module: null, search: '' })
  const [dataSourceListOptions, setDataSourceListOptions] = useState([])
  //const [variables,setVariables] = useState([{dataSourceName:'IPD',columns:['hn','vn'],query:'select hn,vn from patient'}])
  const [showModal, setShowModal] = useState(false)
  const [dsMode, setDsMode] = useState(false)
  const [activeSource, setActiveSource] = useState({})
  const updateData = (field, value, item) => {
    setState({ ...state, [field]: value })
    if (field === 'dataSourceName') {
      const find = variables.find(
        (e) => e.dataSourceName === item.dataSourceName,
      )
      if (!find) {
        props.onChange([].concat(variables).concat([item]))
      }
    } else {
    }
  }

  const toggleCheckbox = () => {
    let newValue = state.orientation == 'landscape' ? 'portrait' : 'landscape'

    setState({ ...state, ['orientation']: newValue })
  }

  const onModalHide = () => {
    setShowModal(false)
    setActiveSource({})
  }

  const onSave = (value) => {
    //setVariables(variables.concat([value]))
    value.dataSourceName = value.name
    const findIndex = variables.findIndex(
      (e) => e.dataSourceId === value.dataSourceId,
    )
    if (findIndex >= 0) {
      variables[findIndex] = value
      //console.log('v', value, variables)
      props.onChange([].concat(variables), value.dataSourceId)
    } else {
      props.onChange(variables.concat([value]), value.dataSourceId)
    }
  }

  const onEdit = (item, index) => {
    // console.log("e",item,index)
    setActiveSource(item)
    setShowModal(true)
    setDsMode('edit')
  }

  const onDelete = (item, index) => {
    props.onChange(
      variables.reduce((rresult, vitem, vindex) => {
        if (index !== vindex) {
          rresult.push(vitem)
        }
        return rresult
      }, []),
    )
  }

  const onMenuOpen = async () => {
    let list = await httpClient
      .get('/coresystem/syreportdatasource')
      .then(({ data }) => data.data)
    setDataSourceListOptions(
      list.map((item, index) => {
        return {
          label: item.dataSourceName,
          value: item.dataSourceId,
          item: item,
        }
      }),
    )
    console.log('list', list)
  }

  const onSearch = () => {}

  const renderInput = (title, field) => {
    return (
      <FormGroup row>
        <Form.Control
          type="text"
          name="value"
          autoComplete="off"
          placeholder={title}
          value={state[field]}
          onChange={(e) => updateData(field, e.target.value)}
        />
        <FeatherIcon
          size="20"
          icon="edit"
          className="vx-icon "
          onClick={() => onSearch()}
        />
      </FormGroup>
    )
  }

  const renderVariables = (item, index) => {
    const vars = item.fieldVariable?.columns || []
    const searchInputs = [...new Set(item.params?.inputs || [])]
    const dataSourceVariableName = getDataSourceVariableName(item)

    return (
      <div key={index}>
        <ConfigItemGroup
          item={Object.assign(item, {
            name: item.dataSourceName,
            type: 'advance_table',
            left: 50,
            top: 50,
            width: 'calc(100% - 1in)',
            height: '40px',
            rowHeight: '40px',
            rowPerPage: 20,
          })}
        >
          <div className="d-inline-flex flex-column my-auto">
            <span className="font-weight-bold text-primary">
              {item.dataSourceName}
            </span>
            <span className="text-muted" style={{ fontSize: 12, lineHeight: 1 }}>
              ตัวแปร: {dataSourceVariableName ? `{${dataSourceVariableName}}` : '-'}
            </span>
          </div>
          <FeatherIcon
            size="20"
            icon="edit"
            className="vx-icon ml-25 my-50 text-muted"
            onClick={() => onEdit(item, index)}
          />
          <FeatherIcon
            size="20"
            icon="trash"
            className="vx-icon ml-25 my-50 text-c-red"
            onClick={() => onDelete(item, index)}
          />
          <FeatherIcon
            size="20"
            icon="refresh-cw"
            className="vx-icon ml-25 my-50 text-c-primary"
            onClick={() => {
              props.handleSync(item)
            }}
          />

          {vars.map((item, index) => (
            <ConfigItem
              key={index}
              name={item}
              description={
                dataSourceVariableName ? `{${dataSourceVariableName}.${item}}` : ''
              }
              item={{ name: item, type: 'object' }}
            />
          ))}

          {searchInputs.map((ele, index) => (
            <ConfigItem
              key={index}
              name={ele}
              item={{ name: ele, type: 'search_param' }}
            />
          ))}
        </ConfigItemGroup>
      </div>
    )
  }

  return (
    <div>
      <FormGroup row>
        <Col md="12">
          <Button
            variant={'light'}
            onClick={() => {
              setDsMode('search')
              setShowModal(true)
            }}
          >
            <FeatherIcon size="16" icon="search" className="vx-icon" />
            ค้นหา
          </Button>
          <Button
            variant="light"
            className="m-l-10"
            onClick={() => {
              setDsMode('new')
              setShowModal(true)
            }}
          >
            <FeatherIcon size="16" icon="plus" className="vx-icon" /> เพิ่ม
          </Button>
        </Col>
      </FormGroup>
      {showModal && (
        <EditDataSourceModal
          show={showModal}
          mode={dsMode}
          value={activeSource}
          categoryList={props.categoryList}
          onHide={() => onModalHide()}
          onSave={(e) => onSave(e)}
        />
      )}

      {variables.map((item, index) => (
        <div key={index}>{renderVariables(item, index)}</div>
      ))}
    </div>
  )
}

export default DataSourceMenu
